exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".links[data-v-3f7bc1ae]{display:flex;margin-right:-12px;margin-bottom:-4px}.links__item[data-v-3f7bc1ae]{font-size:1.0769230769rem;font-weight:bold}.links__item[data-v-3f7bc1ae]:nth-child(n+2){margin-left:6px}.links__icon[data-v-3f7bc1ae]{font-size:10px}.button[data-v-3f7bc1ae]{padding:6px 25px;border-radius:6px 6px 0 0}", ""]);

// exports
